import {apiSlice} from '../apiSlice';

const USERS_URL = '/auth';

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/authenticate`,
                method: 'POST',
                body: data,
            }),
        }),
        getMe: builder.query({
            query: (token) => ({
                url: `${USERS_URL}/me`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            })
        }),
        resetPassword: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/reset-password`,
                method: 'POST',
                body: data
            })
        }),
        getToken: builder.query({
            query: (id) => ({
                url: `${USERS_URL}/token/${id}`,
                method: 'GET',
            })
        }),
        newPassword: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/new-password`,
                method: 'POST',
                body: data
            })
        }),
        logout: builder.mutation({
            query: (data) => ({
                url: `${USERS_URL}/logout`,
                method: 'POST',
                headers: {
                    "x-access-token": data
                },
            }),
        })
    }),
});

export const {
    useResetPasswordMutation,
    useGetMeQuery,
    useNewPasswordMutation,
    useGetTokenQuery,
    useLoginMutation,
    useLogoutMutation,
} = authApiSlice;
